export enum ModalName {
  EditTeamDetails = 'EditTeamDetails',
  RemoveFromTeam = 'RemoveFromTeam',
  RemoveRole = 'RemoveRole',
  DiscardChanges = 'DiscardChanges',
  DuplicateRole = 'DuplicateRole',
  EmptyRole = 'EmptyRole',
  TransferOwnership = 'TransferOwnership',
  CannotRemoveRole = 'CannotRemoveRole',
  LeaveTeam = 'LeaveTeam',
  ViewRolePermissions = 'ViewRolePermissions',
  Error = 'Error',
  EnforceContributorsUpgrade = 'EnforceContributorsUpgrade',
}
